import { styled } from 'styled-components';
import { Action } from '../../Action';
export const AlertBannerDismissButton = styled(Action).withConfig({
  componentId: "aui__sc-53j66u-0"
})(["color:currentcolor;flex-shrink:0;margin-right:var(--aui-spacing-200);margin-top:var(--aui-spacing-100);padding:var(--aui-spacing-100);&:not(:disabled):hover{color:currentcolor;}&:not(:disabled):active{box-shadow:none;}"]);